import React, { useCallback } from 'react'
import CloseIcon from 'Components/close-icon'

const delete_icon = require('static/delete-icon.png')
const delete_icon_hover = require('static/trash-bin-hover.png')
interface IControllerCardProps {
  text: string
  icon: string
  name: string
  title: string
  children?: React.ReactNode
  showChildren?: boolean
  onClick?: (name: string) => void
  onDeleteAll: () => void
  onClose: () => void
  showDelete: boolean
  disabled?: boolean
}

export default function ControllerCard(props: IControllerCardProps) {
  const {
    text,
    icon,
    name,
    title,
    children,
    showChildren = false,
    onClick,
    onClose,
    showDelete,
    onDeleteAll,
    disabled = false,
  } = props
  const handleClick = useCallback(() => {
    if (!disabled && onClick) {
      onClick(name)
    }
  }, [onClick])
  return (
    <div className="controller-card">
      <div className="card" onClick={handleClick}>
        <img src={icon} className="card-icon" />
        <span className="card-name">{text}</span>
        {showDelete && (
          <span
            className="delete-icon"
            onClick={e => {
              e.stopPropagation()
              e.preventDefault()
              onDeleteAll()
            }}
          />
        )}
        {name === 'video' && (
          <div className="video-duration-hint">支持3s-60s</div>
        )}
      </div>
      {showChildren && (
        <div className="uploader-wrapper">
          <CloseIcon onClick={onClose} />
          <p className="title">{title}</p>
          {children}
        </div>
      )}
      <style jsx>
        {`
          .controller-card {
            margin-right: 8px;      
            border-radius: 2px;
            border: solid 0.5px #c9cbd6;
            position: relative;
            margin-top: 8px;
          }

          .card{
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 14px;
            line-height: 20px;
            color: #1f2129;
            padding: 6px 16px;
            cursor: ${disabled ? 'not-allowed' : 'pointer'};  
          }
          .card-icon {
            width: 18px;
            height: 18px;
            object-fit: contain;
            object-position: center;
            margin-right: 4px;
          }
          .card-name{
            max-width: 84px;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
          .delete-icon{
            background-image: url("${delete_icon}");
            background-size: contain;
            background-position: center;
            width: 18px;
            height: 18px;
            margin-left: 12px;
            position: relative;
          }
          .delete-icon:hover{
            background-image: url("${delete_icon_hover}")
          }

          .delete-icon::before{
            position: absolute;
            left: -5px;
            top: 4px;
            content: '';
            width: 1px;
            height: 10px;
            background-color: #e6e8f2;
          }

          .video-duration-hint{
            position: absolute;
            top: -8px;
            left: 22px;
            text-align: center;
            font-size: 12px;
            line-height: 17px;
            color: #e62021;
            background-color: white;
            width: 76px;
            height: 19px;
            transform: scale(.8333);
            transform-origin: left top;
          }
          .video-duration-hint::before{
            content: '';
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            background-color: rgba(230, 32, 33, 0.1);
            border-radius: 8px 8px 8px 0;
            z-index: -1;
          }

          .uploader-wrapper{
            min-width: 318px;
            overflow: visible;
            padding: 16px;
            border-radius: 2px;
            box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.08);
            background-color: white;
            position: absolute;
            bottom: 40px;
            left: 0;
            z-index: 1;
            display: flex;
            flex-direction: column;
          }
          .title {
            height: 20px;
            font-size: 14px;
            font-weight: 500;
          }
          
        `}
      </style>
    </div>
  )
}
